import React from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";

interface FormHeaderProps {
  title: string; // The heading text (e.g., "Add Item", "Edit Item")
  firstLabel?: string; // Label for the list page in breadcrumb (e.g., "Item", "User")
  secondLabel?: string; // label for the form page in breadcrumb (e.g., "Add Item", "Edit Item")
  handleArrowClick?: () => void; // Optional function for back arrow click to navigate to the previous page
  handleBreadcrumbClick?: () => void; // Optional function for back navigation for breadcrumb to navigate to the provided path
}

const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  firstLabel,
  secondLabel,
  handleArrowClick,
  handleBreadcrumbClick,
}) => {
  const navigate = useNavigate();

  /**
   * Handles the navigation for the arrow icon and breadcrumb.
   * If handleArrowClick is provided, it will be called and navigate to the provided path.
   * If handleBreadcrumbClick is provided, it will be called and navigate to the provided path.
   * Otherwise, it will navigate back using the navigate function to the previous page.
   */
  const handleArrowNavigation = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else if (handleArrowClick) {
      handleArrowClick();
    } else if (handleBreadcrumbClick) {
      handleBreadcrumbClick();
    } else {
      navigate(-1);
    }
  };

  const handleBreadcrumbNavigation = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else if (handleBreadcrumbClick) {
      handleBreadcrumbClick();
    } else if (handleArrowClick) {
      handleArrowClick();
    } else {
      navigate(-1);
    }
  };

  if(!firstLabel || !secondLabel) {
    return (
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 py-3">
        <h5 className="mb-0 fw-bold">{title}</h5>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
      {/* Left: Back icon and heading */}
      <div className="d-flex align-items-center gap-2">
        <span
          style={{ fontSize: "24px", cursor: "pointer" }}
          onClick={handleArrowNavigation}
        >
          ←
        </span>
        <h5 className="mb-0 fw-bold">{title}</h5>
      </div>

      {/* Right: Breadcrumb */}
      <Breadcrumb
        firstLabel={firstLabel}
        secondLabel={secondLabel}
        handleBack={handleBreadcrumbNavigation}
      />
    </div>
  );
};

export default FormHeader;
